import { getEventHubApiRoot } from '../../../../../infrastructure/utils/common.utils';
import { HubPublicDetailsDTO } from './hub-preview-sync.types';

export const fetchPublicHubDetails = async (subdomain: string): Promise<HubPublicDetailsDTO> => {
    const apiRoot = getEventHubApiRoot();
    const url = `${apiRoot}/public/hub/${encodeURIComponent(subdomain)}?_=${Date.now()}`;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        cache: 'no-store',
    });

    if (!response.ok) {
        throw new Error(`Failed to load public hub details (${response.status})`);
    }

    return response.json() as Promise<HubPublicDetailsDTO>;
};
